import initModal from '../modal';

const registerArchivingRestoring = () => {
  initModal('.archive-object', '.archive-modal', {".modal-object-name": "object-name"});
  initModal('.restore-object', '.restore-modal', {".modal-object-name": "object-name"});
  initModal('.user-coordinator', '.coordinator-modal', {".modal-object-name": "object-name"});
  initModal('.user-contributor', '.contributor-modal', {".modal-object-name": "object-name"});
  initModal('.user-manager', '.manager-modal', {".modal-object-name": "object-name"});
};

window.registerArchivingRestoring = registerArchivingRestoring;
